(function(){
  var sel='.section-head,.card,.step,.timeline__item,.review,.stat';
  var els=[].slice.call(document.querySelectorAll(sel));
  if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches||window.innerWidth<750) els=[];
  els.forEach(function(el){
    el.classList.add('reveal');
    var sib=el.parentElement?[].slice.call(el.parentElement.children).indexOf(el):0;
    if(sib>0&&sib<4) el.classList.add('reveal-d'+sib);
  });
  var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:0,rootMargin:'0px 0px -6% 0px'});
  els.forEach(function(el){io.observe(el);});
  // Count-up for stats
  [].slice.call(document.querySelectorAll('[data-count-to]')).forEach(function(el){
    var to=parseFloat(el.dataset.countTo),suf=el.dataset.suffix||'',done=false;
    new IntersectionObserver(function(en,o){if(en[0].isIntersecting&&!done){done=true;o.disconnect();var t0=null;
      requestAnimationFrame(function step(t){t0=t0||t;var p=Math.min((t-t0)/1400,1);el.textContent=Math.round(to*(1-Math.pow(1-p,3)))+suf;if(p<1)requestAnimationFrame(step);});}}).observe(el);
  });
})();
